// Content types
export const contentTypes = {
  articles: {
    prefixName: "Artiklar",
    types: ["Så gör andra", "Forskning", "Nyheter"],
  },
};
